module.exports = __webpack_public_path__ + "img/voucher-event.181561eb.svg";